import { SelectOption } from '@globaleris/ui.library'
import moment from 'moment'
import { EnumEstadoFichero, EnumGrupoDocumento, EnumTipoDocumento } from '../../api'
import { apiDownloadFiles } from '../../api/Pioneer/endpoints/files/files.api'
import { ApiLogisticElements } from '../../api/Pioneer/endpoints/logisticElements/logisticElements.api'
import {
  fetchRegulatoryReportsLng,
  fetchRegulatoryReportsOperation,
  fetchRegulatoryReportsPosition,
  fetchRegulatoryReportsStorage,
  fetchReportFiles,
  fetchReportFilesByGroups,
  generateLngReport,
  generateNonSCT2Report,
  generateRegulatoryReportsPowerCommodity,
  generateRegulatoryReportsPowerCommodityAsync,
  generateSCT1Report,
  generateStorageParticipantReport,
  getRRMs
} from '../../api/Pioneer/endpoints/regulatoryReports/regulatoryReports.api'
import { EnumFileType } from '../../api/Pioneer/enums/enumFileType'
import { EnumTipoOperacion } from '../../api/oData/enums/enumTipoOperacion'
import { EnumRegulatoryReportState } from '../../api/oData/requests/enumRegulatoryReportState'
import { enumKeyToValue, enumValueToKey } from '../../helpers/enumHelper'
import { mapFileStreamToFile } from '../../helpers/fileStreamToFile'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../helpers/serviceResponseHelper'
import i18n from '../../i18n'
import { ActionIcons, DataTableActionConfiguration } from '../../model'
import { ServiceResponse } from '../../model/serviceResponse'
import { getActiveBalanceZone, getActiveCompany } from '../../redux'
import {
  GenerateRegulatoryReportAPIRequest,
  GenerateRegulatoryReportRequest,
  GenerateReportRequest,
  GenerateReportRequestTable1,
  regulatoryReportDownloadCard,
  remitReportLngModel,
  remitReportOperationModel,
  remitStorageReportModel
} from './regulatoryReports.Model'
import {
  remitLngReportsListItemsMapper,
  remitReportFilesListItemsMapper,
  remitStorageReportsListItemsMapper,
  remitTableOperationReportsListItemsMapper,
  remitTablePositionReportsListItemsMapper
} from './regulatoryReports.mapper'
export const fetchRegulatoryReportsRemitTableListItems = async (
  startDate: Date,
  endDate: Date,
  grouped?: boolean,
  operationType?: number
): Promise<ServiceResponse<any>> => {
  const operationTypesToFilter = operationType
    ? [enumValueToKey(EnumTipoOperacion, operationType)]
    : [
        enumValueToKey(EnumTipoOperacion, EnumTipoOperacion.Compra),
        enumValueToKey(EnumTipoOperacion, EnumTipoOperacion.Venta)
      ]

  if (grouped) {
    return await fetchRegulatoryReportsPosition(operationTypesToFilter, startDate, endDate)
      .then(res => {
        return createSuccessServiceResponse(remitTablePositionReportsListItemsMapper(res))
      })
      .catch(error => {
        return createErrorServiceResponse(error)
      })
  } else {
    return await fetchRegulatoryReportsOperation(operationTypesToFilter, startDate, endDate)
      .then(res => {
        return createSuccessServiceResponse(remitTableOperationReportsListItemsMapper(res))
      })
      .catch(error => {
        return createErrorServiceResponse(error)
      })
  }
}

const apiLogisticElements = new ApiLogisticElements()

// export const generateRegulatoryReportsPowerCommodity = async (
//   startDate: Date,
//   endDate: Date,
//   operationType?: number
// ): Promise<ServiceResponse<any>> => {
//   console.log('dentro de service')
//   const operationTypesToFilter = operationType
//     ? [enumValueToKey(EnumTipoOperacion, operationType)]
//     : [
//       enumValueToKey(EnumTipoOperacion, EnumTipoOperacion.Compra),
//       enumValueToKey(EnumTipoOperacion, EnumTipoOperacion.Venta)
//     ];
//   return await fetchRegulatoryReportsPowerCommodity(operationTypesToFilter, startDate, endDate)
//     .then(res => {
//       return createSuccessServiceResponse(remitTablePositionReportsListItemsMapper(res));
//     })
//     .catch(error => {
//       return createErrorServiceResponse(error);
//     });

// };

export const generateRegulatoryReport = async (item: GenerateRegulatoryReportRequest) => {
  return await generateRegulatoryReportsPowerCommodity(item)
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const generateRegulatoryReportAsync = async (
  item: GenerateRegulatoryReportRequest
): Promise<ServiceResponse<any>> => {
  // Temporary until API its finished.
  const request: GenerateRegulatoryReportAPIRequest = {
    ...item,
    startDate: moment(item.startDate).format('YYYY-MM-DD'),
    endDate: moment(item.endDate).format('YYYY-MM-DD')
  }

  await generateRegulatoryReportsPowerCommodityAsync(request)
  return { success: true }

  // return await apiRunPriceEngine(priceId).then(response => {
  // return { success: true };
  // return createSuccessServiceResponse(response);
  // });
  // .catch(error => {
  //   return createErrorServiceResponse(error);
  // });
}

export const fetchRegulatoryReportsRemitStorageListItems = async (
  startDate: Date,
  endDate: Date,
  operationType?: number,
  idElemLog?: number | undefined
): Promise<ServiceResponse<any>> => {
  const operationTypesToFilter = operationType
    ? [enumKeyToValue(EnumTipoOperacion, operationType)]
    : [enumValueToKey(EnumTipoOperacion, EnumTipoOperacion.Existencias)]

  return await fetchRegulatoryReportsStorage(operationTypesToFilter, startDate, endDate, idElemLog)
    .then(res => {
      return createSuccessServiceResponse(remitStorageReportsListItemsMapper(res))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchRegulatoryReportsRemitLngListItems = async (
  startDate: Date,
  endDate: Date,
  operationType?: number
): Promise<ServiceResponse<any>> => {
  const operationTypesToFilter = operationType
    ? [enumKeyToValue(EnumTipoOperacion, operationType)]
    : [
        enumValueToKey(EnumTipoOperacion, EnumTipoOperacion.DescargaBuque),
        enumValueToKey(EnumTipoOperacion, EnumTipoOperacion.CargaBuque)
      ]

  return await fetchRegulatoryReportsLng(operationTypesToFilter, startDate, endDate)
    .then(res => {
      return createSuccessServiceResponse(remitLngReportsListItemsMapper(res))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchReportFilesListItems = async (
  documentType: EnumTipoDocumento
): Promise<ServiceResponse<any>> => {
  const activeBalanceZone = getActiveBalanceZone()?.id
  const activecompany = getActiveCompany()?.id

  return await fetchReportFiles(
    activeBalanceZone!,
    activecompany!,
    enumKeyToValue(EnumTipoDocumento, documentType)
  )
    .then(res => {
      return createSuccessServiceResponse(remitReportFilesListItemsMapper(res))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchReportFilesByGroupsListItems = async (
  groupsDocument: EnumGrupoDocumento[]
): Promise<ServiceResponse<any>> => {
  return await fetchReportFilesByGroups(groupsDocument)
    .then(res => {
      return createSuccessServiceResponse(remitReportFilesListItemsMapper(res))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const downloadRegulatoryReportFile = async (
  row: regulatoryReportDownloadCard
): Promise<ServiceResponse<File | undefined>> => {
  return await apiDownloadFiles({
    blobFiles: [
      { documentType: EnumFileType.Document, documentId: row.fileId, fileName: row.fileName }
    ]
  })
    .then(response => createSuccessServiceResponse(mapFileStreamToFile(response)))
    .catch(error => createErrorServiceResponse(error))
}

export const downloadCoresReportFile = async (
  row: regulatoryReportDownloadCard
): Promise<ServiceResponse<File | undefined>> => {
  return await apiDownloadFiles({
    blobFiles: [
      {
        documentType: EnumFileType.RegulatoryDocument,
        regulatoryReportId: row.fileId,
        fileName: row.fileName
      }
    ]
  })
    .then(response => createSuccessServiceResponse(mapFileStreamToFile(response)))
    .catch(error => createErrorServiceResponse(error))
}

export const filterApplicableActionsConfigurationRemit = (
  item: regulatoryReportDownloadCard,
  configurations: Array<DataTableActionConfiguration>
): Array<DataTableActionConfiguration> => {
  let applicableActionsConfiguration: Array<DataTableActionConfiguration> = []
  configurations.forEach(configuration => {
    switch (configuration.icon) {
      case ActionIcons.LOADING: {
        if (
          enumKeyToValue(EnumEstadoFichero, item.fileState) ===
            enumKeyToValue(EnumEstadoFichero, EnumEstadoFichero.EnProceso) &&
          enumKeyToValue(EnumEstadoFichero, item.fileState) !==
            enumKeyToValue(EnumEstadoFichero, EnumEstadoFichero.Esperando)
        ) {
          applicableActionsConfiguration.push(configuration)
        }
        break
      }
    }
  })

  return applicableActionsConfiguration
}

export const getGlobalActionsConfiguration = (): Array<DataTableActionConfiguration> => {
  return [getStateLoadingAction()]
}

const getStateLoadingAction = (): DataTableActionConfiguration => {
  return {
    icon: ActionIcons.LOADING,
    tooltip: i18n.t('regulatoryReports:dataTable.tooltips.loading'),
    isLoading: true
  }
}

//#region SEND

export const infoSendRemitTableMassive = (items: any[]): boolean => {
  return items.find(x => x.state !== EnumRegulatoryReportState.Pendiente) !== undefined
}

export const generateSCT1 = async (item: GenerateReportRequestTable1) => {
  return await generateSCT1Report(item)
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const generateNonSCT2 = async (item: GenerateReportRequest) => {
  return await generateNonSCT2Report(item)
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const generateStorageParticipant = async (item: GenerateReportRequest) => {
  return await generateStorageParticipantReport(item)
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const generateLng = async (item: GenerateReportRequest) => {
  return await generateLngReport(item)
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const getGenerateReportsRemitRequest = (
  items: remitReportOperationModel[],
  initDate: Date,
  endDate: Date,
  type: number,
  rrm: number
): GenerateReportRequest => {
  return (
    items && {
      balanceZone: getActiveBalanceZone()?.id!,
      company: getActiveCompany()?.id!,
      initDate: moment(initDate).format('YYYY-MM-DD'),
      endDate: moment(endDate).format('YYYY-MM-DD'),
      type: type,
      cdTrade: items.every(current => current.tradeCode === items[0].tradeCode)
        ? items[0].tradeCode
        : null,
      rRM: rrm,
      sendState: null
    }
  )
}

export const getGenerateReportsRemitTable1Request = (
  items: remitReportOperationModel[],
  // initDate: Date,
  // endDate: Date,
  type: number,
  rrm: number
): GenerateReportRequestTable1 => {
  return (
    items && {
      balanceZone: getActiveBalanceZone()?.id!,
      company: getActiveCompany()?.id!,
      //initDate: moment(initDate).format('YYYY-MM-DD'),
      //endDate: moment(endDate).format('YYYY-MM-DD'),
      type: type,
      tradesList: items.every(current => current.tradeCode === items[0].tradeCode)
        ? [items[0].tradeCode]
        : [],
      rRM: rrm,
      sendState: null
    }
  )
}

export const getGenerateReportsStorageRequest = (
  items: remitStorageReportModel[],
  initDate: Date,
  endDate: Date,
  type: number,
  rrm: number,
  idElemLog?: number | undefined
): GenerateReportRequest => {
  return (
    items && {
      balanceZone: getActiveBalanceZone()?.id!,
      company: getActiveCompany()?.id!,
      initDate: moment(initDate).format('YYYY-MM-DD'),
      endDate: moment(endDate).format('YYYY-MM-DD'),
      type: type,
      cdTrade: null,
      rRM: rrm,
      sendState: null,
      infrastructures: typeof idElemLog === 'number' ? [idElemLog] : []
    }
  )
}

export const getGenerateReportsLngRequest = (
  items: remitReportLngModel[],
  initDate: Date,
  endDate: Date,
  type: number,
  rrm: number
): GenerateReportRequest => {
  return (
    items && {
      balanceZone: getActiveBalanceZone()?.id!,
      company: getActiveCompany()?.id!,
      initDate: moment(initDate).format('YYYY-MM-DD'),
      endDate: moment(endDate).format('YYYY-MM-DD'),
      type: type,
      cdTrade: null,
      rRM: rrm,
      sendState: null
    }
  )
}

export const getGenerateRegulatoryReport = (
  startDate: Date,
  endDate: Date,
  reportType: number,
  commodity: number
): GenerateRegulatoryReportRequest => {
  return {
    company: getActiveCompany()?.id!,
    idZonaBalance: getActiveBalanceZone()?.id!,
    startDate: moment(startDate).format('YYYY-MM-DD'),
    endDate: moment(endDate).format('YYYY-MM-DD'),
    reportType: reportType,
    commodity: commodity
  }
}

export const getRRMSubjects = async (): Promise<ServiceResponse<any>> => {
  let balanceZone = getActiveBalanceZone()?.id!
  return await getRRMs(balanceZone)
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchLogisticElements = async (): Promise<SelectOption[]> => {
  let balanceZone = getActiveBalanceZone()?.id!
  const data = await apiLogisticElements.FetchByType(balanceZone, [30])
  return data
}

//#endregion
